import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const CorporateBus35Seater = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>35-Seater Corporate Bus</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>35-Seater Corporate Bus Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we provide premium 35-seater buses tailored for business and corporate travel. 
          Whether it’s daily employee transport, MICE events, conferences, or airport pickups for clients — our 
          executive-class buses offer the right blend of space, comfort, and professionalism.
        </p>

        <h2 style={styles.subHeader}>Ideal For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Corporate Employee Transport</li>
          <li style={styles.listItem}>Conferences & Trade Events</li>
          <li style={styles.listItem}>Airport to Hotel Shuttle</li>
          <li style={styles.listItem}>Team Outings & Business Tours</li>
          <li style={styles.listItem}>Executive Guest Logistics</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Executive push-back seats for 35 passengers</li>
          <li style={styles.listItem}>Fully Air-Conditioned with onboard Wi-Fi (on request)</li>
          <li style={styles.listItem}>USB charging ports & reading lights</li>
          <li style={styles.listItem}>Curtains, bottle holders & mobile stands</li>
          <li style={styles.listItem}>Clean interiors and daily sanitization</li>
          <li style={styles.listItem}>Punctual, uniformed, and trained chauffeurs</li>
        </ul>

        <h2 style={styles.subHeader}>Why Corporates Trust eTravo:</h2>
        <p style={styles.paragraph}>
          We partner with top businesses to provide reliable, safe, and timely transport for executives and teams. 
          With a focus on hygiene, maintenance, and customer support, <strong>eTravo</strong> ensures your corporate logistics are 
          handled professionally and seamlessly.
        </p>

      

        <h2 style={styles.subHeader}>Ready to Move Your Team?</h2>
        <p style={styles.paragraph}>
          Book your corporate transport with <strong>eTravo</strong> and travel stress-free. Get in touch with our team 
          for a quote or to schedule your fleet in advance.
        </p>
      </div>
    </>
  );
};

export default CorporateBus35Seater;
